// @ts-check
import RoleMenu from './menu.js';

RoleMenu.define('role-menu');

export default RoleMenu;
export * from './menu.js';

/**
 * @type {import("./menu-globals.js")}
 */
